<template>
    <div>
        <div class="loading-indicator" :class="{dark: 'dark' === mode}" :style="spinnerStyle">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <div v-if="text">{{text}}</div>
        <div v-else-if="showLongLoadingInfo" class="loading-text" :class="{dark: 'dark' === mode}">
            Das dauert länger als erwartet. Bitte habe etwas Geduld.
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-property-decorator';

    @Component({
        name: 'LoadingIndicator',
    })
    export default class LoadingIndicator extends Vue {
        time = Date.now();

        createdTime = Date.now();

        interval: number = 0;

        @Prop({
            type: Number,
            default: 10,
        }) timeout: number;

        @Prop({
            type: String,
            default: '',
        }) text: string;

        @Prop({
            type: String,
            default: 'light',
        }) mode: 'light' | 'dark';

        @Prop({
            type: Object,
            default()
            {
                return {};
            },
        }) spinnerStyle: object;

        get showLongLoadingInfo()
        {
            return (this.time - this.createdTime) > (1000 * this.timeout);
        }

        created()
        {
            const now = Date.now();

            this.time = now;
            this.createdTime = now;

            this.interval = window.setInterval(() => {
                this.time = Date.now();
            }, 1000);
        }

        beforeDestroy()
        {
            this.interval && window.clearInterval(this.interval);
        }
    }
</script>
